<template>
  <div>
    <div class="row mb-4">
      <div class="col-md-2 mb-1">
        <label>ID do Pedido</label>
        <input type="text" class="form-control" v-model="filtro.id" />
      </div>
      <div class="col-md-2 mb-1">
        <label>Material</label>
        <input
          type="text"
          class="form-control"
          v-model="filtro.material"
          placeholder="Buscar material..."
        />
      </div>
      <div class="col-md-2 mb-1">
        <label>Grupo</label>
        <v-select
          v-model="filtro.grupo"
          :options="gruposDisponiveis"
          :reduce="(g) => g.value"
          :label="'label'"
          :searchable="true"
          :clearable="true"
          placeholder="Selecionar grupo..."
          class="vselect"
          :disabled="materiaisSolicitados.length === 0"
        />
      </div>
      <div class="col-md-2 mb-1">
        <label>Data de</label>
        <input type="date" class="form-control" v-model="filtro.data_de" />
      </div>
      <div class="col-md-2 mb-1">
        <label>Data até</label>
        <input type="date" class="form-control" v-model="filtro.data_ate" />
      </div>
      <div class="col-md-2 mb-1">
        <br />
        <button class="btn btn-secondary mr-2" @click="limparFiltros()">
          Limpar
        </button>
        <button
          class="btn btn-success"
          @click="exportarParaExcel()"
          v-if="dadosFiltrados.length > 0"
        >
          Exportar Excel
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <b-card title="Pesquisa por Unidade">
          <div class="row">
            <div class="col-md-12 mb-4">
              <label for="unidadeSelect">Pesquisar Unidade:</label>
              <v-select
                id="unidadeSelect"
                v-model="unidadesSelecionadas"
                :options="unidadesFiltradas"
                :label="'nome'"
                :filterable="false"
                :searchable="true"
                :multiple="true"
                placeholder="Digite para buscar uma ou mais unidades..."
                @search="onSearch"
                @input="onUnidadesSelected"
                :loading="loadingUnidades"
                :reduce="(unidade) => unidade"
                class="vselect"
                :clearSearchOnSelect="false"
                :clearable="true"
              >
                <template v-slot:no-options="{ search, searching }">
                  <div
                    v-if="searching && search.length >= 3 && !loadingUnidades"
                  >
                    Nenhuma unidade encontrada para "{{ search }}"
                  </div>
                  <div v-else-if="searching && search.length < 3">
                    Digite pelo menos 3 caracteres para buscar
                  </div>
                  <div v-else-if="loadingUnidades">Buscando unidades...</div>
                  <div v-else>Digite para buscar unidades</div>
                </template>
              </v-select>
            </div>

            <!-- Exibir unidades selecionadas -->
            <div v-if="unidadesSelecionadas.length > 0" class="col-md-12 mb-3">
              <div
                class="d-flex justify-content-between align-items-center mb-3"
              >
                <h5 class="mb-0">
                  Unidades Selecionadas ({{ unidadesSelecionadas.length }}):
                </h5>
                <b-button
                  variant="primary"
                  @click="pesquisarMateriais"
                  :disabled="loadingMateriais"
                >
                  <b-spinner v-if="loadingMateriais" small></b-spinner>
                  {{
                    loadingMateriais ? "Pesquisando..." : "Pesquisar Materiais"
                  }}
                </b-button>
              </div>
              <div class="row">
                <div
                  class="col-md-4 mb-2"
                  v-for="unidade in unidadesSelecionadas"
                  :key="unidade.id"
                >
                  <b-card class="unidade-info mb-0">
                    <strong>{{ unidade.nome }}</strong>
                    <div v-if="unidade.sigla" class="small text-muted">
                      Sigla: {{ unidade.sigla }}
                    </div>
                    <div v-if="unidade.cnes" class="small text-muted">
                      CNES: {{ unidade.cnes }}
                    </div>
                  </b-card>
                </div>
              </div>
            </div>

            <!-- Tabela de Materiais solicitados pela unidade -->
            <div v-if="materiaisSolicitados.length > 0" class="col-md-12">
              <b-card>
                <div
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <h5 class="mb-0">
                    Materiais solicitados pelas unidades selecionadas
                  </h5>
                  <div class="d-flex align-items-center">
                    <b-badge variant="info" class="mr-3"
                      >{{ dadosFiltrados.length }} de
                      {{ materiaisSolicitados.length }} registros
                      encontrados</b-badge
                    >
                    <span class="text-muted mr-3" v-if="totalPaginas > 1"
                      >Página {{ paginaAtual }} de {{ totalPaginas }}</span
                    >

                    <!-- Seletor de registros por página -->
                    <div
                      class="d-flex align-items-center"
                      v-if="totalPaginas > 1"
                    >
                      <label class="mr-2 mb-0 text-muted"
                        >Registros por página:</label
                      >
                      <select
                        class="form-control form-control-sm"
                        style="width: auto"
                        v-model="registrosPorPagina"
                      >
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-hover table-dark-responsive">
                    <thead>
                      <tr>
                        <th>ID Pedido</th>
                        <th>Unidade</th>
                        <th>Material</th>
                        <th>Grupo</th>
                        <th>Sub Grupo</th>
                        <th>Valor Médio</th>
                        <th>Data do Pedido</th>
                        <th>Quantidade Solicitada</th>
                        <th>Quantidade Atendida</th>
                        <th>Baixa de Estoque</th>
                        <th>Status do Pedido</th>
                        <th>Tipo</th>
                        <th class="text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in dadosPaginados"
                        :key="`${item.unidade_id}-${item.pedido_id}-${item.material_pedido_id}`"
                      >
                        <td>
                          <strong>#{{ item.pedido_id }}</strong>
                        </td>
                        <td>
                          {{ item.unidade_nome || "-" }}
                        </td>
                        <td>
                          <strong>{{
                            item.material_nome || "Não informado"
                          }}</strong>
                          <div
                            v-if="item.material_codigo"
                            class="text-muted small"
                          >
                            Código: {{ item.material_codigo }}
                          </div>
                        </td>
                        <td>
                          {{ item.grupo_nome || "-" }}
                        </td>
                        <td>
                          {{ item.subgrupo_nome || "-" }}
                        </td>
                        <td>
                          <span v-if="item.preco_medio">
                            {{ formatarMoeda(item.preco_medio) }}
                          </span>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td>
                          {{ formatarData(item.data_pedido) }}
                        </td>
                        <td>
                          <b-badge variant="secondary">{{
                            item.quantidade_solicitada
                          }}</b-badge>
                        </td>
                        <td>
                          <b-badge variant="info">{{
                            item.quantidade_atendida || 0
                          }}</b-badge>
                        </td>
                        <td>
                          <b-badge variant="success">{{
                            item.baixa_estoque || 0
                          }}</b-badge>
                        </td>
                        <td>
                          <b-badge :variant="getStatusVariant(item.status)">
                            {{ getStatusText(item.status) }}
                          </b-badge>
                        </td>
                        <td>
                          <span
                            class="badge badge-primary"
                            v-show="item.data_inicio && item.data_fim"
                            >Pedido semanal</span
                          >
                          <span
                            class="badge badge-warning"
                            v-show="
                              !item.data_inicio &&
                              !item.data_fim &&
                              !item.suplementar &&
                              !item.rapido
                            "
                            >Pedido SOS</span
                          >
                          <span
                            class="badge badge-secondary"
                            v-show="
                              !item.data_inicio &&
                              !item.data_fim &&
                              item.suplementar
                            "
                            >Pedido Suplementar</span
                          >
                          <span
                            class="badge badge-info"
                            v-show="
                              !item.data_inicio && !item.data_fim && item.rapido
                            "
                            >Pedido Rápido</span
                          >
                        </td>
                        <td class="text-center">
                          <router-link
                            :to="`/pedidos/view/${item.pedido_id}`"
                            class="btn btn-sm btn-primary btn-ver-pedido"
                            @click.native="
                              console.log(
                                'Clicando pedido:',
                                item.pedido_id,
                                'Status na tabela:',
                                item.status,
                                'Status texto:',
                                getStatusText(item.status)
                              )
                            "
                          >
                            <i class="fas fa-eye"></i> Ver Pedido
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Controles de Paginação -->
                <div
                  v-if="totalPaginas > 1"
                  class="d-flex justify-content-center align-items-center mt-3"
                >
                  <button
                    class="btn btn-sm btn-outline-secondary mr-2"
                    @click="irParaPagina(1)"
                    :disabled="paginaAtual === 1"
                  >
                    <i class="fas fa-angle-double-left"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-secondary mr-2"
                    @click="irParaPagina(paginaAtual - 1)"
                    :disabled="paginaAtual === 1"
                  >
                    <i class="fas fa-angle-left"></i> Anterior
                  </button>

                  <span class="mx-3"
                    >Página {{ paginaAtual }} de {{ totalPaginas }}</span
                  >

                  <button
                    class="btn btn-sm btn-outline-secondary mr-2"
                    @click="irParaPagina(paginaAtual + 1)"
                    :disabled="paginaAtual === totalPaginas"
                  >
                    Próximo <i class="fas fa-angle-right"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-secondary"
                    @click="irParaPagina(totalPaginas)"
                    :disabled="paginaAtual === totalPaginas"
                  >
                    <i class="fas fa-angle-double-right"></i>
                  </button>
                </div>
              </b-card>
            </div>

            <!-- Mensagem quando não há resultados -->
            <div
              v-else-if="pesquisaRealizada && materiaisSolicitados.length === 0"
              class="col-md-12"
            >
              <b-alert show variant="info" class="text-center">
                <i class="fas fa-info-circle"></i>
                As unidades selecionadas ainda não solicitaram nenhum
                material.
              </b-alert>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  BCard,
  BCardText,
  BButton,
  BSpinner,
  BBadge,
  BAlert,
} from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  name: "PesquisaUnidadeCrud",
  components: {
    BCard,
    BCardText,
    BButton,
    BSpinner,
    BBadge,
    BAlert,
    vSelect,
  },
  data() {
    return {
      filtro: {
        id: "",
        material: "",
        grupo: null,
        data_de: "",
        data_ate: "",
      },
      unidadesSelecionadas: [],
      unidadesFiltradas: [],
      materiaisSolicitados: [],
      loadingUnidades: false,
      loadingMateriais: false,
      pesquisaRealizada: false,
      searchTimeout: null,
      // Controles de paginação
      paginaAtual: 1,
      registrosPorPagina: 25,
    };
  },
  computed: {
    dadosFiltrados() {
      let dados = this.materiaisSolicitados;

      // Filtrar por ID do pedido
      if (this.filtro.id) {
        dados = dados.filter((item) =>
          item.pedido_id.toString().includes(this.filtro.id)
        );
      }

      // Filtrar por Material (ignorando acentos)
      if (this.filtro.material) {
        const materialBusca = this.removerAcentos(
          this.filtro.material.toLowerCase()
        );
        dados = dados.filter((item) => {
          const materialNome = this.removerAcentos(
            (item.material_nome || "").toLowerCase()
          );
          const materialCodigo = this.removerAcentos(
            (item.material_codigo || "").toLowerCase()
          );
          return (
            materialNome.includes(materialBusca) ||
            materialCodigo.includes(materialBusca)
          );
        });
      }

      // Filtrar por Grupo (comparação exata pelo valor selecionado no v-select)
      if (this.filtro.grupo) {
        dados = dados.filter((item) => item.grupo_nome === this.filtro.grupo);
      }

      // Filtrar por data de
      if (this.filtro.data_de) {
        dados = dados.filter((item) => {
          const dataPedido = new Date(item.data_pedido)
            .toISOString()
            .split("T")[0];
          const dataFiltro = this.filtro.data_de;
          return dataPedido >= dataFiltro;
        });
      }

      // Filtrar por data até
      if (this.filtro.data_ate) {
        dados = dados.filter((item) => {
          const dataPedido = new Date(item.data_pedido)
            .toISOString()
            .split("T")[0];
          const dataFiltro = this.filtro.data_ate;
          return dataPedido <= dataFiltro;
        });
      }

      return dados;
    },

    // Computed properties para paginação
    totalPaginas() {
      return Math.ceil(this.dadosFiltrados.length / this.registrosPorPagina);
    },

    dadosPaginados() {
      const inicio = (this.paginaAtual - 1) * this.registrosPorPagina;
      const fim = inicio + this.registrosPorPagina;
      return this.dadosFiltrados.slice(inicio, fim);
    },

    gruposDisponiveis() {
      const nomesVistos = new Set();
      return this.materiaisSolicitados
        .filter((item) => item.grupo_nome)
        .reduce((acc, item) => {
          if (!nomesVistos.has(item.grupo_nome)) {
            nomesVistos.add(item.grupo_nome);
            acc.push({ label: item.grupo_nome, value: item.grupo_nome });
          }
          return acc;
        }, [])
        .sort((a, b) => a.label.localeCompare(b.label));
    },
  },
  watch: {
    // Resetar página quando filtros mudarem
    filtro: {
      handler() {
        this.paginaAtual = 1;
      },
      deep: true,
    },
    // Resetar página quando mudar registros por página
    registrosPorPagina() {
      this.paginaAtual = 1;
    },
  },
  methods: {
    onSearch(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        if (!search || search.length === 0) {
          // Se apagou tudo, reseta lista
          this.carregarUnidadesIniciais();
          return;
        }

        if (search.length >= 3) {
          this.buscarUnidades(search);
        }
      }, 300);
    },

    async buscarUnidades(termo) {
      try {
        this.loadingUnidades = true;

        const api = this.$store.state.api + "unidades";

        const params = {
          nome: termo,
          export_all: true,
          limit: 20,
        };

        const response = await axios.get(api, { params });

        const unidades = response.data.data || response.data;

        this.unidadesFiltradas = unidades.map((unidade) => ({
          ...unidade,
          name: unidade.nome,
        }));
      } catch (error) {
        console.error("Erro ao buscar unidades:", error);
        this.$toast.error("Erro ao buscar unidades");
        this.unidadesFiltradas = [];
      } finally {
        this.loadingUnidades = false;
      }
    },

    onUnidadesSelected(unidades) {
      this.unidadesSelecionadas = unidades;
      this.materiaisSolicitados = [];
      this.pesquisaRealizada = false;
    },

    async pesquisarMateriais() {
      if (!this.unidadesSelecionadas || this.unidadesSelecionadas.length === 0) {
        this.$toast.warning("Selecione ao menos uma unidade primeiro");
        return;
      }

      try {
        this.loadingMateriais = true;
        this.pesquisaRealizada = false;
        this.paginaAtual = 1;
        this.filtro.grupo = null;

        const resultadosPorUnidade = await Promise.all(
          this.unidadesSelecionadas.map((unidade) => {
            const api =
              this.$store.state.api +
              `pesquisa-unidade/${unidade.id}/materiais`;

            return axios
              .get(api, { params: { export_all: true } })
              .then((response) => ({ unidade, response }));
          })
        );

        const materiais = [];
        resultadosPorUnidade.forEach(({ unidade, response }) => {
          if (!response.data || !response.data.data) {
            return;
          }

          response.data.data.forEach((materialPedido) => {
            materiais.push({
              pedido_id: materialPedido.pedido_id,
              material_pedido_id: materialPedido.id,
              unidade_id: unidade.id,
              unidade_nome: unidade.nome,
              unidade_rotas: unidade.rotas || [],
              quantidade_solicitada: materialPedido.quantidade_solicitada,
              quantidade_atendida: materialPedido.quantidade_atendida || 0,
              baixa_estoque: materialPedido.baixa_estoque || 0,
              data_pedido:
                materialPedido.pedido?.created_at || materialPedido.created_at,
              status: materialPedido.pedido ? materialPedido.pedido.status : 0,
              material_nome: materialPedido.material?.nome || "Não informado",
              material_codigo: materialPedido.material?.codigo || null,
              grupo_nome: materialPedido.material?.grupo?.nome || null,
              subgrupo_nome: materialPedido.material?.subgrupo?.nome || null,
              preco_medio: materialPedido.material?.preco_medio || null,
              data_inicio: materialPedido.pedido?.data_inicio || null,
              data_fim: materialPedido.pedido?.data_fim || null,
              suplementar: materialPedido.pedido?.suplementar || false,
              rapido: materialPedido.pedido?.rapido || false,
            });
          });
        });

        materiais.sort(
          (a, b) => new Date(b.data_pedido) - new Date(a.data_pedido)
        );

        this.materiaisSolicitados = materiais;
        this.pesquisaRealizada = true;
      } catch (error) {
        console.error("Erro ao pesquisar materiais:", error);
        this.$toast.error("Erro ao pesquisar materiais das unidades");
        this.materiaisSolicitados = [];
        this.pesquisaRealizada = true;
      } finally {
        this.loadingMateriais = false;
      }
    },

    limparFiltros() {
      this.filtro = {
        id: "",
        material: "",
        grupo: null,
        data_de: "",
        data_ate: "",
      };
    },

    removerAcentos(str) {
      if (!str) return "";
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },

    formatarData(data) {
      if (!data) return "-";
      return new Date(data).toLocaleDateString("pt-BR");
    },

    formatarMoeda(valor) {
      if (!valor) return "-";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
    },

    getStatusText(status) {
      const statusMap = {
        0: "Solicitado",
        1: "Rejeitado",
        2: "Aguardando retirada",
        3: "Em transporte",
        4: "Recebido",
        5: "Finalizado",
        6: "Cancelado",
        7: "Recebido parcialmente",
        8: "Em separação",
        9: "Aprovado",
        10: "Pendente baixa de estoque",
        11: "Autorizado",
        12: "Entregue",
        13: "Não entregue",
      };
      return statusMap[status] || "Desconhecido";
    },

    getStatusVariant(status) {
      const variantMap = {
        0: "primary", // Solicitado
        1: "danger", // Rejeitado
        2: "secondary", // Aguardando retirada
        3: "warning", // Em transporte
        4: "info", // Recebido
        5: "dark", // Finalizado
        6: "danger", // Cancelado
        7: "warning", // Recebido parcialmente
        8: "warning", // Em separação
        9: "success", // Aprovado
        10: "primary", // Pendente baixa de estoque
        11: "primary", // Autorizado
        12: "success", // Entregue
        13: "danger", // Não entregue
      };
      return variantMap[status] || "secondary";
    },

    async exportarParaExcel() {
      // Usar os dados filtrados que estão sendo exibidos na tabela
      const dadosParaExportar = this.dadosFiltrados;

      if (dadosParaExportar.length === 0) {
        this.$toast.warning("Não há dados para exportar.");
        return;
      }

      try {
        // Criar JSON com os dados filtrados
        const jsonData = dadosParaExportar.map((item) => ({
          "ID Pedido": item.pedido_id,
          Material: item.material_nome || "Não informado",
          "Código Material": item.material_codigo || "N/A",
          Grupo: item.grupo_nome || "N/A",
          "Sub Grupo": item.subgrupo_nome || "N/A",
          "Valor Médio": item.preco_medio
            ? this.formatarMoeda(item.preco_medio)
            : "N/A",
          "Data do Pedido": this.formatarData(item.data_pedido),
          "Quantidade Solicitada": item.quantidade_solicitada,
          "Quantidade Atendida": item.quantidade_atendida || 0,
          "Baixa de Estoque": item.baixa_estoque || 0,
          Status: this.getStatusText(item.status),
          Tipo: this.getTipoPedido(item),
          Rotas:
            item.unidade_rotas && item.unidade_rotas.length
              ? item.unidade_rotas.map((r) => r.nome).join(", ")
              : "N/A",
          Unidade: item.unidade_nome || "N/A",
        }));

        // Criar e baixar arquivo Excel
        const nomeUnidadesArquivo =
          this.unidadesSelecionadas.length === 1
            ? this.unidadesSelecionadas[0].nome.replace(/[^a-zA-Z0-9]/g, "_")
            : `${this.unidadesSelecionadas.length}_Unidades`;

        this.downloadExcel(
          jsonData,
          `Materiais_Unidade_${nomeUnidadesArquivo}_${
            new Date().toISOString().split("T")[0]
          }`
        );

        this.$toast.success("Arquivo Excel exportado com sucesso!");
      } catch (error) {
        console.error("Erro ao exportar Excel:", error);
        this.$toast.error("Erro ao exportar arquivo Excel");
      }
    },

    downloadExcel(data, filename) {
      // Criar cabeçalho
      const headers = Object.keys(data[0]);

      // Criar linhas de dados
      const rows = data.map((row) => Object.values(row));

      // Função para limpar e formatar células com largura automática
      const formatCell = (cell, columnIndex) => {
        if (cell === null || cell === undefined) return "";

        let cellStr = String(cell).trim();

        // Calcular largura necessária baseada no conteúdo da coluna
        const header = headers[columnIndex];
        const headerLength = header ? header.length : 0;
        const cellLength = cellStr.length;

        // Usar o maior entre header e conteúdo, com padding mínimo
        const targetWidth = Math.max(headerLength, cellLength) + 2;

        // Adicionar espaços para ajustar largura se necessário
        if (cellLength < targetWidth) {
          const paddingNeeded = targetWidth - cellLength;
          const leftPadding = Math.floor(paddingNeeded / 2);
          const rightPadding = paddingNeeded - leftPadding;
          cellStr = `"${" ".repeat(leftPadding)}${cellStr}${" ".repeat(
            rightPadding
          )}"`;
        } else {
          // Se contém ponto e vírgula ou aspas, colocar entre aspas
          if (cellStr.includes(";") || cellStr.includes('"')) {
            cellStr = `"${cellStr.replace(/"/g, '""')}"`;
          }
        }

        return cellStr;
      }; // Usar ponto e vírgula (padrão brasileiro do Excel)
      const separator = ";";

      // Criar CSV limpo
      let csvContent = "";

      // Adicionar cabeçalho
      csvContent +=
        headers.map((header) => formatCell(header)).join(separator) + "\r\n";

      // Adicionar dados
      rows.forEach((row) => {
        const formattedRow = row.map((cell, index) => {
          return formatCell(cell, index);
        });
        csvContent += formattedRow.join(separator) + "\r\n";
      });

      // Criar arquivo XLS (Excel nativo) com BOM UTF-8
      const blob = new Blob(["\ufeff" + csvContent], {
        type: "application/vnd.ms-excel;charset=utf-8;",
      });

      // Fazer download como .xls (Excel nativo)
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${filename}.xls`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    getTipoPedido(item) {
      if (item.data_inicio && item.data_fim) return "Pedido semanal";
      if (item.suplementar) return "Pedido Suplementar";
      if (item.rapido) return "Pedido Rápido";
      return "Pedido SOS";
    },

    // Métodos de paginação
    irParaPagina(numeroPagina) {
      if (numeroPagina >= 1 && numeroPagina <= this.totalPaginas) {
        this.paginaAtual = numeroPagina;
      }
    },

    async carregarUnidadesIniciais() {
      try {
        const api = this.$store.state.api + "unidades";

        const params = {
          export_all: true,
          limit: 50,
        };

        const response = await axios.get(api, { params });

        const unidades = response.data.data || response.data;

        this.unidadesFiltradas = unidades.map((unidade) => ({
          ...unidade,
          name: unidade.nome,
        }));
      } catch (error) {
        console.error("Erro ao carregar unidades iniciais:", error);
      }
    },
  },

  mounted() {
    // Carregar algumas unidades iniciais para facilitar a busca
    this.carregarUnidadesIniciais();

    console.log("API URL:", this.$store.state.api);
  },
};
</script>

<style scoped>
.unidade-info {
  background: #f8f9fa;
  border-left: 4px solid #007bff;
}

.btn-ver-pedido {
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
}

.table-dark-responsive {
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  color: #212529;
  /* Cor escura para modo light */
}

.table-dark-responsive th {
  background: white;
  color: #212529;
  border-color: #dee2e6;
}

.table-dark-responsive td {
  background-color: white;
  color: #212529;
  /* Cor escura para modo light */
  border-color: #dee2e6;
}

/* Garantir que títulos e texto sejam escuros no modo light */
h5,
.card-title {
  color: #212529;
}

label {
  color: #495057;
}

/* Garantir cores apropriadas para cards no modo light */
.card {
  background-color: white;
  color: #212529;
}

.card-body {
  color: #212529;
}

/* Campos de formulário no modo light */
.form-control {
  background-color: white;
  color: #495057;
  border-color: #ced4da;
}

.vselect {
  min-height: 38px;
}

/* Estilos do v-select para modo light */
.vs__dropdown-toggle {
  background-color: white;
  border-color: #ced4da;
}

.vs__dropdown-toggle input {
  color: #495057;
}

.vs__selected {
  color: #495057;
}

.vs__search::placeholder {
  color: #6c757d;
}

.vs__dropdown-menu {
  background-color: white;
  border-color: #ced4da;
  color: #495057;
}

.vs__dropdown-option {
  color: #495057;
}

.vs__dropdown-option--highlight {
  background-color: #007bff;
  color: white;
}

.badge {
  font-size: 0.75rem;
}

/* Modo dark - múltiplos seletores para compatibilidade */
.dark-layout .table-dark-responsive,
[data-theme="dark"] .table-dark-responsive,
.theme-dark .table-dark-responsive,
body.dark .table-dark-responsive {
  background-color: #283046 !important;
  color: #b4b7bd !important;
  border: 1px solid #3b4253 !important;
}

.dark-layout .table-dark-responsive th,
[data-theme="dark"] .table-dark-responsive th,
.theme-dark .table-dark-responsive th,
body.dark .table-dark-responsive th {
  background-color: #283046 !important;
  color: #b4b7bd !important;
  border-color: #3b4253 !important;
}

.dark-layout .table-dark-responsive td,
[data-theme="dark"] .table-dark-responsive td,
.theme-dark .table-dark-responsive td,
body.dark .table-dark-responsive td {
  background-color: #283046 !important;
  color: #b4b7bd !important;
  border-color: #3b4253 !important;
}

.dark-layout .table-dark-responsive tbody tr:hover,
[data-theme="dark"] .table-dark-responsive tbody tr:hover,
.theme-dark .table-dark-responsive tbody tr:hover,
body.dark .table-dark-responsive tbody tr:hover {
  background-color: #3b4253 !important;
}

.dark-layout .unidade-info,
[data-theme="dark"] .unidade-info,
.theme-dark .unidade-info,
body.dark .unidade-info {
  background-color: #283046 !important;
  color: #b4b7bd !important;
  border-left: 4px solid #7367f0 !important;
}

/* Campo de seleção de unidade no modo dark */
.dark-layout .vs__dropdown-toggle,
[data-theme="dark"] .vs__dropdown-toggle,
.theme-dark .vs__dropdown-toggle,
body.dark .vs__dropdown-toggle {
  background-color: #283046 !important;
  border-color: #3b4253 !important;
}

.dark-layout .vs__dropdown-toggle input,
[data-theme="dark"] .vs__dropdown-toggle input,
.theme-dark .vs__dropdown-toggle input,
body.dark .vs__dropdown-toggle input {
  color: #b4b7bd !important;
}

.dark-layout .vs__selected,
[data-theme="dark"] .vs__selected,
.theme-dark .vs__selected,
body.dark .vs__selected {
  color: #b4b7bd !important;
}

.dark-layout .vs__search::placeholder,
[data-theme="dark"] .vs__search::placeholder,
.theme-dark .vs__search::placeholder,
body.dark .vs__search::placeholder {
  color: #6c757d !important;
}

.dark-layout .vs__dropdown-menu,
[data-theme="dark"] .vs__dropdown-menu,
.theme-dark .vs__dropdown-menu,
body.dark .vs__dropdown-menu {
  background-color: #283046 !important;
  border-color: #3b4253 !important;
  color: #b4b7bd !important;
}

.dark-layout .vs__dropdown-option,
[data-theme="dark"] .vs__dropdown-option,
.theme-dark .vs__dropdown-option,
body.dark .vs__dropdown-option {
  color: #b4b7bd !important;
}

.dark-layout .vs__dropdown-option--highlight,
[data-theme="dark"] .vs__dropdown-option--highlight,
.theme-dark .vs__dropdown-option--highlight,
body.dark .vs__dropdown-option--highlight {
  background-color: #7367f0 !important;
  color: #fff !important;
}

/* Títulos das seções no modo dark */
.dark-layout .card-title,
[data-theme="dark"] .card-title,
.theme-dark .card-title,
body.dark .card-title {
  color: #b4b7bd !important;
}

.dark-layout h5,
[data-theme="dark"] h5,
.theme-dark h5,
body.dark h5 {
  color: #b4b7bd !important;
}

/* Cards no modo dark */
.dark-layout .card,
[data-theme="dark"] .card,
.theme-dark .card,
body.dark .card {
  background-color: #283046 !important;
  border-color: #3b4253 !important;
}

.dark-layout .card-body,
[data-theme="dark"] .card-body,
.theme-dark .card-body,
body.dark .card-body {
  background-color: #283046 !important;
  color: #b4b7bd !important;
}

/* Botão Ver Pedido - manter visibilidade */
.btn-ver-pedido {
  background-color: #007bff !important;
  border-color: #007bff !important;
  color: #fff !important;
}

.btn-ver-pedido:hover {
  background-color: #0056b3 !important;
  border-color: #004085 !important;
  color: #fff !important;
}

/* Campos de filtro no modo dark */
.dark-layout .form-control,
[data-theme="dark"] .form-control,
.theme-dark .form-control,
body.dark .form-control {
  background-color: #283046 !important;
  border-color: #3b4253 !important;
  color: #b4b7bd !important;
}

.dark-layout .form-control:focus,
[data-theme="dark"] .form-control:focus,
.theme-dark .form-control:focus,
body.dark .form-control:focus {
  background-color: #283046 !important;
  border-color: #7367f0 !important;
  color: #b4b7bd !important;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.25) !important;
}

.dark-layout .form-control::placeholder,
[data-theme="dark"] .form-control::placeholder,
.theme-dark .form-control::placeholder,
body.dark .form-control::placeholder {
  color: #6c757d !important;
}

/* Labels no modo dark */
.dark-layout label,
[data-theme="dark"] label,
.theme-dark label,
body.dark label {
  color: #b4b7bd !important;
}

/* Alertas no modo dark */
.dark-layout .alert-info,
[data-theme="dark"] .alert-info,
.theme-dark .alert-info,
body.dark .alert-info {
  background-color: #1f3a5f !important;
  border-color: #2e5984 !important;
  color: #a7c1e8 !important;
}

/* Botões no modo dark */
.dark-layout .btn-secondary,
[data-theme="dark"] .btn-secondary,
.theme-dark .btn-secondary,
body.dark .btn-secondary {
  background-color: #495057 !important;
  border-color: #495057 !important;
  color: #fff !important;
}

.dark-layout .btn-success,
[data-theme="dark"] .btn-success,
.theme-dark .btn-success,
body.dark .btn-success {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
  color: #fff !important;
}
</style>